module.exports = __webpack_public_path__ + "static/media/S4N1-3.af5f841c.svg";